import P5Dynamic from "../../../../src/components/p5-dynamic";
import sketch from "../../../../content/blog/random-walk/sketch-random-walk";
import * as React from 'react';
export default {
  P5Dynamic,
  sketch,
  React
};